import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/assets/landing-feature-customization.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/assets/landing-feature-generation.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/assets/landing-feature-history.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/assets/landing-feature-stats.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/AnimatedCubeSpinner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/RenderOn/Idle/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/RenderOn/InView/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/RenderOn/Timeout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LuminousAnimationCard","LuminousAnimationHandler"] */ "/vercel/path0/apps/web/src/layouts/institucional/Elements/LuminousAnimation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/layouts/institucional/Section/CTA/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/layouts/institucional/Section/Demo/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/layouts/institucional/Section/Elements/Text/styles.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/layouts/institucional/Section/Features/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/layouts/institucional/Section/Hero/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/layouts/institucional/Section/Metrics/MetricsPure/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/layouts/institucional/Section/Metrics/MetricsRealtime/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/layouts/institucional/Section/Presentation/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/layouts/institucional/Section/styles.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next-bricks/dist/index.js");
